import { api } from "./api.ts";

export type OrganizationBySlugRequest = {
  slug: string;
};

export type OrganizationBySlugResponse = {
  name: string;
};

export const organizationAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganizationBySlug: build.mutation<
      OrganizationBySlugResponse,
      { accessToken?: string; intakeToken?: string; slug: string }
    >({
      query: ({ accessToken, intakeToken, slug }) => {
        // the backend endpoint requires authentication, so we need a token
        if (!accessToken && !intakeToken) {
          throw new Error(
            "Authentication token required for organization lookup",
          );
        }

        // use the appropriate authentication header based on token type
        const authHeader = intakeToken
          ? `Intake-Bearer ${intakeToken}`
          : `Bearer ${accessToken}`;

        return {
          url: `api/v1/by-slug/`,
          method: "POST",
          headers: { Authorization: authHeader },
          body: { slug },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetOrganizationBySlugMutation } = organizationAPI;
